import React from 'react';
import classNames from 'classnames/bind';
import { Input, Link, ReloadIcon } from '@beef/ui-kit';
import { useFetchCaptcha } from "./hooks/useFetchCaptcha";
import { useCaptchaInput } from "./hooks/useCaptchaInput";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var Captcha = function Captcha(_ref) {
  var handleErrorStatus = _ref.handleErrorStatus,
    isError = _ref.isError,
    onChange = _ref.onChange,
    onRefresh = _ref.onRefresh,
    _ref$texts = _ref.texts,
    texts = _ref$texts === void 0 ? {} : _ref$texts,
    captchaKey = _ref.captchaKey,
    refreshToken = _ref.refreshToken,
    setCaptchakey = _ref.setCaptchakey;
  var imgSrc = useFetchCaptcha({
    captchaKey: captchaKey,
    refreshToken: refreshToken,
    setCaptchakey: setCaptchakey
  });
  var _useCaptchaInput = useCaptchaInput({
      errorText: texts.errorText,
      handleErrorStatus: handleErrorStatus,
      isError: isError,
      onChange: onChange,
      onRefresh: onRefresh
    }),
    inputRef = _useCaptchaInput.inputRef,
    handleFocus = _useCaptchaInput.handleFocus,
    errorMessage = _useCaptchaInput.errorMessage,
    handleChange = _useCaptchaInput.handleChange,
    value = _useCaptchaInput.value,
    handleBlur = _useCaptchaInput.handleBlur,
    handleRefresh = _useCaptchaInput.handleRefresh;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('container'),
    "data-t-id": "components-Captcha"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('title')
  }, /*#__PURE__*/React.createElement(Link, {
    buttonVariant: "plain",
    href: "",
    onClick: handleRefresh,
    rightIcon: /*#__PURE__*/React.createElement(ReloadIcon, {
      size: "xs"
    }),
    size: "size5-r-s",
    variant: "button"
  }, texts.reloadText)), /*#__PURE__*/React.createElement("div", {
    className: cx('captcha')
  }, /*#__PURE__*/React.createElement("img", {
    alt: "captcha",
    src: imgSrc
  }), /*#__PURE__*/React.createElement(Input, {
    autoComplete: "off",
    errorMessage: errorMessage,
    inputRef: inputRef,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    placeholder: texts.placeholder,
    type: "number",
    value: value
  })));
};